import { useModal } from "@/providers/modal-provider";
import { ImageIcon } from "lucide-react";
import Image from "next/image";

type ProductTileProps = {
	id?: string;
	name: string;
	description?: string;
	slug: string;
	logo: string | undefined;
};

const ProductTile = ({ name, logo, slug }: ProductTileProps) => {
	const { openProductDetailsModal } = useModal();

	const showProductDetailsModal = () => {
		const url = `/products/${slug}`;
		history.pushState({}, "", url);
		openProductDetailsModal(slug);
	};

	return (
		<div
			onClick={showProductDetailsModal}
			className="flex cursor-pointer items-center justify-center rounded-lg bg-white p-2"
		>
			<div className="flex h-20 w-20 items-center justify-center rounded-xl bg-white">
				{logo ? (
					<Image
						src={logo}
						alt={name}
						width={80}
						height={80}
						className="h-full w-full rounded-lg object-contain"
					/>
				) : (
					<ImageIcon className="h-5 w-5 text-gray-400" />
				)}
			</div>
		</div>
	);
};

export default ProductTile;
